import React from 'react';
import { motion } from 'framer-motion';
import Topbar from '../../Topbar';
import { useTheme } from '../../ThemeContext';
import { useOutletContext } from 'react-router-dom';

// Données simulées basées sur tes Enums (Engineering, Data Science, etc.)
const TOP_PLAYERS = [
  { rank: '01', name: 'Layla Hassan', dept: 'ENGINEERING', score: 9850, avatar: 'LH', color: '#3b82f6' },
  { rank: '02', name: 'Omar Khalil', dept: 'DESIGN', score: 9720, avatar: 'OK', color: '#6366f1' },
  { rank: '03', name: 'Sara Chen', dept: 'DATA', score: 9640, avatar: 'SC', color: '#06b6d4' },
  { rank: '04', name: 'Zakaria K.', dept: 'ENGINEERING', score: 8450, avatar: 'ZK', color: '#8b5cf6', isUser: true },
  { rank: '05', name: 'Priya Patel', dept: 'PRODUCT', score: 8320, avatar: 'PP', color: '#ec4899' },
];

export default function Leaderboard() {
  const { C } = useTheme();
  const { onMenuClick } = useOutletContext();
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: C.bgDeep, minHeight: '100vh',overflowY: 'auto', }}>
      <Topbar title="Leaderboard" onMenuClick={onMenuClick}/>
      
      <div style={{ padding: "32px", maxWidth: "1400px", margin: "0 auto", width: "100%" }}>
        
        {/* Résumé des statistiques (Basé sur Difficulty & Experience) */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
          gap: '24px',
          marginBottom: '40px' 
        }}>
          <StatCard label="GLOBAL RANK" value="#42" sub="Top 2% Globally" C={C} />
          <StatCard label="DIFFICULTY MASTERED" value="EXPERT" sub="Based on Hard/Expert challenges" C={C} />
          <StatCard label="TOTAL SCORE" value="8,450" sub="Verified by IsAuthenticated" C={C} isTrend />
        </div>

        {/* Grille des classements par Département (Engineering, Design, etc.) */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(480px, 1fr))', 
          gap: '32px' 
        }}>
          
          <RankSection title="Engineering Leaderboard" dept="ENGINEERING" C={C}>
            {TOP_PLAYERS.filter(p => p.dept === 'ENGINEERING' || p.isUser).map(p => (
              <PlayerRow key={p.rank} player={p} C={C} />
            ))}
          </RankSection>

          <RankSection title="Design & Creative" dept="DESIGN" C={C}>
            {TOP_PLAYERS.filter(p => p.dept === 'DESIGN').map(p => (
              <PlayerRow key={p.rank} player={p} C={C} />
            ))}
          </RankSection>

        </div>
      </div>
    </div>
  );
}

/* --- Composants Internes --- */

const StatCard = ({ label, value, sub, C, isTrend }) => (
  <motion.div 
    whileHover={{ scale: 1.02 }}
    style={{
      background: C.bgCard,
      padding: '28px',
      borderRadius: '24px',
      border: `1px solid ${C.border}`,
      boxShadow: '0 10px 30px -15px rgba(0,0,0,0.2)',
      textAlign: 'center'
    }}
  >
    <span style={{ fontSize: '12px', fontWeight: 700, color: C.textMuted, letterSpacing: '1.2px' }}>{label}</span>
    <div style={{ fontSize: '36px', fontWeight: 900, color: C.textPrimary, margin: '12px 0' }}>{value}</div>
    <div style={{ fontSize: '13px', color: isTrend ? '#10b981' : C.textSecond }}>{sub}</div>
  </motion.div>
);

const RankSection = ({ title, sub, C, children }) => (
  <div style={{ background: C.bgCard, borderRadius: '28px', padding: '32px', border: `1px solid ${C.border}` }}>
    <h3 style={{ fontSize: '20px', fontWeight: 800, color: C.textPrimary, marginBottom: '24px' }}>{title}</h3>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {children}
    </div>
  </div>
);

const PlayerRow = ({ player, C }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    borderRadius: '16px',
    background: player.isUser ? 'rgba(99, 102, 241, 0.12)' : 'rgba(255,255,255,0.02)',
    border: `1px solid ${player.isUser ? '#6366f1' : 'transparent'}`,
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      <span style={{ fontWeight: 800, color: C.textMuted, width: '24px' }}>{player.rank}</span>
      <div style={{ 
        width: '44px', height: '44px', borderRadius: '12px', 
        background: player.color, color: '#fff', 
        display: 'flex', alignItems: 'center', justifyContent: 'center', 
        fontWeight: 800 
      }}>
        {player.avatar}
      </div>
      <div>
        <div style={{ fontWeight: 700, color: C.textPrimary }}>
          {player.name} {player.isUser && " (You)"}
        </div>
        <div style={{ fontSize: '12px', color: C.textMuted }}>{player.dept}</div>
      </div>
    </div>
    <div style={{ textAlign: 'right' }}>
      <div style={{ fontWeight: 800, color: C.textPrimary }}>{player.score.toLocaleString()}</div>
      <div style={{ fontSize: '11px', color: '#10b981', fontWeight: 600 }}>↑ 12%</div>
    </div>
  </div>
);